import { ProStudioContext } from '../prostudio.xstate.types';
import { tableStore } from '../../stores/table-store';
import { throwErrorWithId } from '@pypestream/utils';

export const validateVersion = async (ctx: ProStudioContext) => {
  const { botName, customerId, draftVersion, project } = ctx;

  const projectId = project?.id;

  if (!projectId) {
    throwErrorWithId('Project ID is required');
    return;
  }

  if (!botName) {
    throwErrorWithId('Bot Name is required');
    return;
  }

  if (!customerId) {
    throwErrorWithId('Customer ID is required');
    return;
  }

  if (!draftVersion) {
    throwErrorWithId('Draft Version is required');
    return;
  }

  await tableStore.validate({
    projectId,
    customerId,
    botName,
    draftVersion,
  });
};
